const buttonStates = new WeakMap()

const loadingLabel = (button) => button.dataset.loadingMessage ?? button.dataset.disableWith ?? "Working..."

const beginButtonFeedback = (event) => {
  const button = event.detail?.formSubmission?.submitter
  if (!(button instanceof HTMLElement) || !button.classList.contains("btn") || buttonStates.has(button)) return

  buttonStates.set(button, {
    ariaBusy: button.getAttribute("aria-busy"),
    content: button instanceof HTMLInputElement ? button.value : button.innerHTML,
    minWidth: button.style.minWidth
  })

  button.style.minWidth = `${Math.ceil(button.getBoundingClientRect().width)}px`
  button.classList.add("is-loading")
  button.setAttribute("aria-busy", "true")

  if (button instanceof HTMLInputElement) {
    button.value = loadingLabel(button)
    return
  }

  const spinner = document.createElement("span")
  spinner.className = "spinner-border spinner-sm"
  spinner.setAttribute("aria-hidden", "true")
  button.replaceChildren(spinner, document.createTextNode(loadingLabel(button)))
}

const endButtonFeedback = (event) => {
  const button = event.detail?.formSubmission?.submitter
  const state = buttonStates.get(button)
  if (!state) return

  if (button instanceof HTMLInputElement) {
    button.value = state.content
  } else {
    button.innerHTML = state.content
  }

  button.style.minWidth = state.minWidth
  button.classList.remove("is-loading")
  if (state.ariaBusy === null) {
    button.removeAttribute("aria-busy")
  } else {
    button.setAttribute("aria-busy", state.ariaBusy)
  }
  buttonStates.delete(button)
}

document.addEventListener("turbo:submit-start", beginButtonFeedback)
document.addEventListener("turbo:submit-end", endButtonFeedback)
